import { ENDPOINT_BASE } from "../../api";
import { useMyHookGetAllEntities } from "../myHooks";

export function useQuerySocialMedia() {
  const apiConfig = {
    endpoint: ENDPOINT_BASE.SOCIAL_MEDIA + "/no-auth",
    queryKeyLabel: "socialMedia",
    retry: 2,
    staleTime: 0,
  };

  const { data, isLoading, isError } = useMyHookGetAllEntities({
    apiConfig,
  });

  return {
    data: data?._embedded?.socialMediaList?.[0] || {},
    isError,
    isLoading,
  };
}
